import Home from './home';
import View from './view';

export default {
  Home,
  View,
};
